import create, { SetState } from 'zustand';

import { InboxEmailLogsType } from '../../../../../features/emailSettings/hooks/useEmailLogs';
import { defaultInboxLogs, IConfiguredAccountsDTO } from '../helper';

export interface IEmailMessage {
  inboxData: InboxEmailLogsType;
  configuredImapAccounts: IConfiguredAccountsDTO[];
  unReadCount: number;
  setInBoxData: (inboxData: InboxEmailLogsType) => void;
  setConfiguredImapAccounts: (configuredImapAccounts: IConfiguredAccountsDTO[]) => void;
  setUnreadCount: (unReadCount: number) => void;
}
export const useNewEmailStore = create<IEmailMessage>((set: SetState<IEmailMessage>) => ({
  inboxData: defaultInboxLogs,
  configuredImapAccounts: [],
  unReadCount: 0,
  setInBoxData: (inboxData: InboxEmailLogsType) => set({ inboxData: inboxData }),
  setConfiguredImapAccounts: (configuredImapAccounts: IConfiguredAccountsDTO[]) =>
    set({ configuredImapAccounts: configuredImapAccounts }),
  setUnreadCount: (unReadCount: number) => set({ unReadCount: unReadCount }),
}));
